import React from 'react'
import { useIntl } from 'react-intl'
import Group from 'components/utils/Group'
import BodyText from 'LuxKit/Typography/BodyText'
import CSSBreakpoint from 'components/utils/CSSBreakpoint'
import TextLink from 'LuxKit/TextLink'
import TextButton from 'LuxKit/Button/TextButton'
import { rem } from 'polished'

/**
 * Sitewide banner content for maldives charter takeover.
 * Palm tree overlays are handled by the background component.
 */
function MaldivesCharterPageBanner() {
  const intl = useIntl()

  const headlineText = intl.formatMessage({
    id: 'RkrzUt9mhh',
    defaultMessage: "Australia's first & only direct Maldives flight",
    description: 'Headline for Maldives charter direct flight promotion',
  })

  // TODO: [i18n] flagged - contains hardcoded pricing "$2,499 pp"
  const pricingText = intl.formatMessage({
    id: 'OrqkMIUqoj',
    defaultMessage: '5N + Flights from $2,499 pp with LuxPlus+',
    description: 'Pricing details for Maldives charter flight package',
  })

  const viewOffersText = intl.formatMessage({
    id: '+9yFlI/pU8',
    defaultMessage: 'View offers',
    description: 'Call-to-action button to view Maldives charter offers',
  })

  return (
    <>
      <CSSBreakpoint max="mobile">
        <Group direction="vertical" verticalAlign="start">
          <BodyText variant="medium" weight="bold">
            {headlineText}
          </BodyText>
          <BodyText variant="small">
            {pricingText}<span style={{ marginRight: rem(8) }} />
            <TextLink to="/campaign/maldives-direct" wrap="no-wrap">{viewOffersText}</TextLink>
          </BodyText>
        </Group>
      </CSSBreakpoint>

      <CSSBreakpoint min="tablet">
        <Group direction="horizontal" gap={12} verticalAlign="center">
          <BodyText variant="medium">
            <b>{headlineText}</b>
            <span style={{ marginRight: rem(8) }} />
            {pricingText}
          </BodyText>

          <TextButton to="/campaign/maldives-direct" size="small" kind="primary">
            {viewOffersText}
          </TextButton>
        </Group>
      </CSSBreakpoint>
    </>
  )
}

export default MaldivesCharterPageBanner
